import { MetricTypes } from 'common/constants/metric-types';

export function getMetricTypeFriendlyName(
  metricType: MetricTypes | string
): string {
  switch (metricType) {
    case MetricTypes.WEB:
      return 'Forms';
    case MetricTypes.INBOUND_CALL:
      return 'Calls';
    case MetricTypes.OPPORTUNITY_VALUES:
      return 'Opportunity Values';
    default:
      return metricType;
  }
}
